import React from 'react'
import Layout from '../../components/layout'
import PageHeader from '../../components/PageHeader'
import Attachments from '../commonSections/attachments'
import PageGallery from '../commonSections/gallery'
import PageAccordion from '../commonSections/accordion'
import PageBody from '../commonSections/body'
import RelatedPosts from '../../sections/RelatedPosts'

const PageTopOnlyFeatImage = ({ page }) => {
    return (
        <Layout>
            <PageHeader title={page.title} subtitle={page?.subtitle} featImg={page?.featuredImage} />
            <PageBody page={page} />
            <PageAccordion page={page} />
            <RelatedPosts blogCategory={page?.blogCategory} blogTags={page?.blogTags} />
            <Attachments attachments={page?.attachments} />
            <PageGallery gallery={page?.gallery} />
        </Layout>
    )
}

export default PageTopOnlyFeatImage
